"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = cardAnswerFeedback;
function cardAnswerFeedback(correct, userAnswer) {
  if (correct !== false) return null;
  return userAnswer !== undefined && userAnswer !== null && String(userAnswer).trim() ? "You answered '".concat(String(userAnswer).trim(), "'") : null;
}